/* @flow */
'use strict';

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var each = require('async/each');

var many = require('pull-many');

var pull = require('pull-stream');

var Key = require('interface-datastore').Key;

var Errors = require('interface-datastore').Errors;

var utils = require('interface-datastore').utils;

var asyncFilter = utils.asyncFilter;
var asyncSort = utils.asyncSort;
var replaceStartWith = utils.replaceStartWith;

var Keytransform = require('./keytransform');
/* ::
import type {Datastore, Callback, Batch, Query, QueryResult} from 'interface-datastore'

type Mount<Value> = {
  prefix: Key,
  datastore: Datastore<Value>
}
*/

/**
 * A datastore that can combine multiple stores inside various
 * key prefixs.
 */


var MountDatastore
/* :: <Value> */
=
/*#__PURE__*/
function () {
  /* :: mounts: Array<Mount<Value>> */
  function MountDatastore(mounts
  /* : Array<Mount<Value>> */
  ) {
    _classCallCheck(this, MountDatastore);

    this.mounts = mounts.slice();
  }

  _createClass(MountDatastore, [{
    key: "open",
    value: function open(callback
    /* : Callback<void> */
    )
    /* : void */
    {
      each(this.mounts, function (m, cb) {
        m.datastore.open(cb);
      }, callback);
    }
    /**
     * Lookup the matching datastore for the given key.
     *
     * @private
     * @param {Key} key
     * @returns {{Datastore, Key, Key}}
     */

  }, {
    key: "_lookup",
    value: function _lookup(key
    /* : Key */
    )
    /* : ?{datastore: Datastore<Value>, mountpoint: Key, rest: Key} */
    {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.mounts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var mount = _step.value;

          if (mount.prefix.toString() === key.toString() || mount.prefix.isAncestorOf(key)) {
            var s = replaceStartWith(key.toString(), mount.prefix.toString());
            return {
              datastore: mount.datastore,
              mountpoint: mount.prefix,
              rest: new Key(s)
            };
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: "put",
    value: function put(key
    /* : Key */
    , value
    /* : Value */
    , callback
    /* : Callback<void> */
    )
    /* : void */
    {
      var match = this._lookup(key);

      if (match == null) {
        return callback(Errors.dbWriteFailedError(new Error('No datastore mounted for this key')));
      }

      match.datastore.put(match.rest, value, callback);
    }
  }, {
    key: "get",
    value: function get(key
    /* : Key */
    , callback
    /* : Callback<Value> */
    )
    /* : void */
    {
      var match = this._lookup(key);

      if (match == null) {
        return callback(Errors.notFoundError(new Error('No datastore mounted for this key')));
      }

      match.datastore.get(match.rest, callback);
    }
  }, {
    key: "has",
    value: function has(key
    /* : Key */
    , callback
    /* : Callback<bool> */
    )
    /* : void */
    {
      var match = this._lookup(key);

      if (match == null) {
        callback(null, false);
        return;
      }

      match.datastore.has(match.rest, callback);
    }
  }, {
    key: "delete",
    value: function _delete(key
    /* : Key */
    , callback
    /* : Callback<void> */
    )
    /* : void */
    {
      var match = this._lookup(key);

      if (match == null) {
        return callback(Errors.dbDeleteFailedError(new Error('No datastore mounted for this key')));
      }

      match.datastore.delete(match.rest, callback);
    }
  }, {
    key: "close",
    value: function close(callback
    /* : Callback<void> */
    )
    /* : void */
    {
      each(this.mounts, function (m, cb) {
        m.datastore.close(cb);
      }, callback);
    }
  }, {
    key: "batch",
    value: function batch()
    /* : Batch<Value> */
    {
      var _this = this;

      var batchMounts = {};

      var lookup = function lookup(key
      /* : Key */
      )
      /* : {batch: Batch<Value>, rest: Key} */
      {
        var match = _this._lookup(key);

        if (match == null) {
          throw new Error('No datastore mounted for this key');
        }

        var m = match.mountpoint.toString();

        if (batchMounts[m] == null) {
          batchMounts[m] = match.datastore.batch();
        }

        return {
          batch: batchMounts[m],
          rest: match.rest
        };
      };

      return {
        put: function put(key
        /* : Key */
        , value
        /* : Value */
        )
        /* : void */
        {
          var match = lookup(key);
          match.batch.put(match.rest, value);
        },
        delete: function _delete(key
        /* : Key */
        )
        /* : void */
        {
          var match = lookup(key);
          match.batch.delete(match.rest);
        },
        commit: function commit(callback
        /* : Callback<void> */
        )
        /* : void */
        {
          each(Object.keys(batchMounts), function (p, cb) {
            batchMounts[p].commit(cb);
          }, callback);
        }
      };
    }
  }, {
    key: "query",
    value: function query(q
    /* : Query<Value> */
    )
    /* : QueryResult<Value> */
    {
      var qs = this.mounts.map(function (m) {
        var ks = new Keytransform(m.datastore, {
          convert: function convert(key
          /* : Key */
          )
          /* : Key */
          {
            throw new Error('should never be called');
          },
          invert: function invert(key
          /* : Key */
          )
          /* : Key */
          {
            return m.prefix.child(key);
          }
        });
        var prefix;

        if (q.prefix != null) {
          prefix = replaceStartWith(q.prefix, m.prefix.toString());
        }

        return ks.query({
          prefix: prefix,
          filters: q.filters,
          keysOnly: q.keysOnly
        });
      });
      var tasks = [many(qs)];

      if (q.filters != null) {
        tasks = tasks.concat(q.filters.map(function (f) {
          return asyncFilter(f);
        }));
      }

      if (q.orders != null) {
        tasks = tasks.concat(q.orders.map(function (o) {
          return asyncSort(o);
        }));
      }

      if (q.offset != null) {
        var i = 0;
        tasks.push(pull.filter(function () {
          return i++ >= q.offset;
        }));
      }

      if (q.limit != null) {
        tasks.push(pull.take(q.limit));
      }

      return pull.apply(null, tasks);
    }
  }]);

  return MountDatastore;
}();

module.exports = MountDatastore;